import { render } from "./ButtonNavigationSwiper.vue?vue&type=template&id=0b329616&scoped=true"
import script from "./ButtonNavigationSwiper.vue?vue&type=script&lang=js"
export * from "./ButtonNavigationSwiper.vue?vue&type=script&lang=js"

import "./ButtonNavigationSwiper.vue?vue&type=style&index=0&id=0b329616&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b329616"]])

export default __exports__